import React from 'react';

import ImageUpload from './ImageUpload';
import ImageUploading, { ImageListType } from 'react-images-uploading';
import { MAX_IMAGE_FILE_SIZE, MAX_IMAGE_NUMBER } from 'constants/createEmployeeForm';

interface ImageUploaderProps {
  onChange: (event: { target: { name: string; value: ImageListType } }) => void;
  onBlur: (event: { target: string }) => void;
  name: string;
  value: ImageListType;
  isButtonsVisible: boolean;
  error?: string | boolean;
}

const ImageUploader: React.FC<ImageUploaderProps> = (props) => {
  const { onChange, name, value, isButtonsVisible, error } = props;

  const maxNumber = MAX_IMAGE_NUMBER;
  const maxFileSize = MAX_IMAGE_FILE_SIZE;
  const handleImageChange = (imageList: ImageListType) => {
    onChange({
      target: {
        name,
        value: imageList,
      },
    });
  };

  return (
    <ImageUploading
      value={value}
      onChange={handleImageChange}
      maxNumber={maxNumber}
      maxFileSize={maxFileSize}
      dataURLKey="data_url"
    >
      {(renderProps) => {
        const { imageList, onImageUpload, onImageUpdate, onImageRemove, isDragging, dragProps, errors } = renderProps;

        return (
          <ImageUpload
            isButtonsVisible={isButtonsVisible}
            imageSelected={imageList.length > 0}
            imageList={imageList}
            onImageUpload={onImageUpload}
            onImageUpdate={onImageUpdate}
            onImageRemove={onImageRemove}
            isDragging={isDragging}
            dragProps={dragProps}
            errors={errors}
            error={error}
          />
        );
      }}
    </ImageUploading>
  );
};

export default ImageUploader;
